(() => {
  const productSelector = 'wrapped-extension[target-group="product-page"]';
  const drawerSelector = 'wrapped-extension[target-group="drawer"]';
  const selector = `${productSelector},${drawerSelector}`;
  const visualVariables = {
    '--shadow-primary-text-color': '#173b31',
    '--shadow-primary-surface': '#fffaf0',
    '--shadow-selection-checked-surface': '#a22d27',
    '--shadow-form-element-border-color': '#173b31',
    '--shadow-form-element-border-color-active': '#a22d27',
    '--shadow-block-border-surface': 'transparent',
    '--shadow-block-padding': '15px 18px 13px',
    '--shadow-border-radius-scale': '48',
  };
  const observedRoots = new WeakSet();

  const ensureDrawerClip = (root) => {
    let style = root.querySelector('style[data-ah-drawer-gift-clip]');

    if (!style) {
      style = document.createElement('style');
      style.setAttribute('data-ah-drawer-gift-clip', '');
      style.textContent = 'wrapped-preset { border-radius: 11px !important; overflow: hidden !important; }';
      root.appendChild(style);
    }
  };

  const applyVisualVariables = (extension) => {
    const root = extension.shadowRoot;

    if (!root) {
      return;
    }

    if (extension.matches(productSelector)) {
      const preset = root.querySelector('wrapped-preset');

      if (preset) {
        Object.entries(visualVariables).forEach(([name, value]) => {
          preset.style.setProperty(name,value,'important');
        });
      }
    }

    if (extension.matches(drawerSelector)) {
      ensureDrawerClip(root);
    }
  };

  const bindExtension = (extension) => {
    if (!(extension instanceof Element) || !extension.matches(selector)) {
      return;
    }

    const refresh = () => {
      const root = extension.shadowRoot;

      if (root && !observedRoots.has(root)) {
        observedRoots.add(root);
        new MutationObserver(() => applyVisualVariables(extension)).observe(root, {
          childList: true,
          subtree: true,
        });
      }

      applyVisualVariables(extension);
    };

    refresh();
    [0, 100, 500, 1500].forEach((delay) => window.setTimeout(refresh, delay));
  };

  const scan = (root = document) => {
    if (root instanceof Element && root.matches(selector)) {
      bindExtension(root);
    }

    root.querySelectorAll?.(selector).forEach(bindExtension);
  };

  customElements.whenDefined('wrapped-extension').then(() => {
    scan();

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) {
            scan(node);
          }
        });
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  });
})();
